// tslint:disable:no-commented-code
// tslint:disable:no-duplicate-string
// tslint:disable:only-arrow-functions
// tslint:disable:no-big-function

import { recommendationsPanelsLocaleKeys } from '@epicuro-next/constants/features/localization';
import { mergeMultipleConfigs } from '@epicuro-next/platform/dynamic-components-utils';

import { createInstanceWithChildren } from '../../../../utils/dynamic-items-utils';
import { ScrollableRecommendationPanelBuilder } from '../../../builders/scrollable-recommendation-panel-builder';
import { SeeMoreSearchByFilters } from '../../../components/see-more-search-by-filters';
import { DEFAULT_ROOT_PROPERTIES } from '../../../properties/default-root-properties';
import { DEFAULT_ROOT_STYLES } from '../../../properties/default-root-styles';
import { PANEL_STYLING_PROPERTIES } from '../../../properties/panel-styling-properties';
import { PANEL_TRACKING_PROPERTIES } from '../../../properties/panel-tracking-properties';
import { PRODUCT_ITEM_VIEW_PROPERTIES } from '../../../properties/product-item-view-properties';
import { SCROLLABLE_PANEL_PROPERTIES } from '../../../properties/scrollable-panel-properties';
import { SEE_MORE_LINK_PROPERTIES } from '../../../properties/see-more-link-properties';
import { SHOW_PANEL } from '../../../properties/show-panel-property';

import { LOOK_AHEAD_PROVIDERS_PROPERTIES } from './look-ahead-provider-properties';
import { itemsInHeaderWrapper } from './products-on-the-way-header-container';

export function createHorizontalScrollablePanelBoughtThisSeason() {
  const root = createInstanceWithChildren({
    id: 'root',
    contentTypeId: 'dynamic-collections-renderer',
    styles: {
      ...DEFAULT_ROOT_STYLES,
    },
    data: {
      ...DEFAULT_ROOT_PROPERTIES,
      ...SCROLLABLE_PANEL_PROPERTIES,
      ...PANEL_TRACKING_PROPERTIES,
      ...PANEL_STYLING_PROPERTIES,
      ...SEE_MORE_LINK_PROPERTIES,
      ...LOOK_AHEAD_PROVIDERS_PROPERTIES,
      ...PRODUCT_ITEM_VIEW_PROPERTIES,
      panelName: 'ProductsOnTheWayTestPanel',
      headerText: recommendationsPanelsLocaleKeys.lookAhead,
      noItemsText:
        recommendationsPanelsLocaleKeys.itSeemsNoItemsHaveBeenOrderedYet,
      showProductCardIcons: true,
      showProductTitle: true,
      showUserNameInPanelTitle: true,
      ...SHOW_PANEL,
      hasHeaderFilters: true,
      productTitleStyle: 'top: -25px;',
    },
    children: [],
  });

  const horizontalScrollablePanelRecommendatonPanel =
    new ScrollableRecommendationPanelBuilder().build();

  root.children.push(
    horizontalScrollablePanelRecommendatonPanel.scrollablePanel,
  );

  return mergeMultipleConfigs(root, [
    {
      id: 'footer-container',
      if: ['EQ', [true, true]],
      children: [SeeMoreSearchByFilters],
    },
    {
      id: 'product-card-icons',
      inputs: {
        showEstimatedDeliveryDate: false,
      },
    },
    {
      id: 'header-container',
      children: [itemsInHeaderWrapper],
    },
    {
      id: 'product-delivery-date-label',
      styles: {
        style: {
          top: '0',
          'font-size': '.8rem',
        },
      },
    },
    {
      id: 'items-array-renderer',
      styles: {
        style: {
          'margin-top': '20px',
        },
      },
    },
  ])[0];
}

export const horizontalScrollablePanelProductsOnTheWay =
  createHorizontalScrollablePanelBoughtThisSeason();
